import { crudRequest } from '@/services/api';
import { getToDay } from '@/utils/date';
import moment from 'moment';
import GenerateCondit from './GenerateCondit';
import { CALCWEIGHT } from './GenerateCondit/Interrelated';
import DeliveryDisAccordRouteDetail from '@/Entity/DeliveryDisAccordRouteDetail';
import { message } from 'antd';

const dateRange = getToDay();

const paramsForm = {
  dateRange: [moment(dateRange[0]), dateRange[1]],
  taskName: null,
  taskStatus: 3,
};

export default {
  namespace: 'filedownload',
  state: {
    searchParams: { ...paramsForm },
    dateFormat: 'YYYY-MM-DD HH:mm:ss',
    pageSize: 20,
    page: 1,
    total: 0,
    fileDataList: [],
    messageInfo: '',
  },

  effects: {
    *getFileList(_, { call, put, select }) {
      const { dateFormat, pageSize, page, searchParams } = yield select(
        ({ filedownload }) => filedownload,
      );
      const { taskName, taskStatus, dateRange } = searchParams;

      const data = yield crudRequest(
        '/api/route/exportTask/queryPageList',
        {
          pageSize,
          page,
          startTime: dateRange[0].format(dateFormat),
          endTime: dateRange[1].format(dateFormat),
          taskName,
          taskStatus: taskStatus === 0 ? null : taskStatus,
        },
        { module: 'basic', reqType: null },
      );
      if (data?.code === 1) {
        const { rows, total } = data?.data;
        yield put({
          type: 'updateState',
          payload: {
            fileDataList: rows?.sort((f, l) => l.id - f.id) || [],
            total: Number.parseInt(total || 0),
          },
        });
      }
    },
    *waybillCashRateExport({ payload }, { call, put, select }) {
      const actualTable = 'static_actual_time_consume_result'; // 实际表
      const preTable = 'static_actual_time_consume_result_sat';
      const dataSource = window.location.port === '16881' ? preTable : actualTable;

      const { endDate, startDate } = payload;
      const condit = new GenerateCondit({
        aggregators: [CALCWEIGHT],
        dataSource,
        dimensions: [
          'waybillNo',
          'onTime',
          'productType',
          'superiorityProduct',
          'areaType',
          'calcWeight',
          'originSite',
          'countyAgingOriginCenter',
          'originRegion',
          'originProvinceArea',
          'destinationSite',
          'countyAgingDestinationCenter',
          'destinationRegion',
          'destinationProvinceArea',
          'sendDate',
          '__time',
          'countyAgingAllAging',
          'actualPeriod',
          'delayPeriod',
          'originCounty',
          'destinationCounty',
        ],
        queryType: 'scan',
        simpleGranularity: 'all',
        endDate,
        startDate,
      }).converCondit({});

      const result = yield crudRequest(
        '/api/route/exportTask/createTask',
        {
          taskName: '运单兑现明细导出',
          taskType: 'waybill_rate',
          isAllSite: 0,
          taskParams: JSON.stringify(condit),
        },
        { module: 'basic' },
      );
      if (result?.code === 1) {
        message.success(result?.message);
        // yield put({ type: 'updateState', payload: { messageInfo: result.message } })
      }
    },
    *waybillDurationExport({ payload }, { call, put, select }) {
      const actualTable = 'static_actual_time_consume_result'; // 实际表
      const preTable = 'static_actual_time_consume_result_sat';
      const dataSource = window.location.port === '16881' ? preTable : actualTable;

      const { endDate, startDate } = payload;
      const condit = new GenerateCondit({
        aggregators: [CALCWEIGHT],
        dataSource,
        dimensions: [
          'waybillNo',
          'productType',
          'superiorityProduct',
          'originSite',
          'originCounty',
          'sendDate',
          'destinationSite',
          'destinationCounty',
          'signDate',
          'countyAgingOriginCenter',
          'originProvinceArea',
          'countyAgingDestinationCenter',
          'destinationProvinceArea',
          'deliveryPeriod',
          'trunkLinePeriod',
          'dispatchPeriod',
          'totalPeriod',
          '__time',
        ],
        queryType: 'scan',
        simpleGranularity: 'all',
        endDate,
        startDate,
      }).converCondit({});

      const result = yield crudRequest(
        '/api/route/exportTask/createTask',
        {
          taskName: '运单时长明细导出',
          taskType: 'waybill_time',
          isAllSite: 0,
          taskParams: JSON.stringify(condit),
        },
        { module: 'basic' },
      );
      if (result?.code === 1) {
        message.success(result?.message);
        // yield put({ type: 'updateState', payload: { messageInfo: result.message } })
      }
    },
    *deliveryDisAccordExport({ payload }, { call, put, select }) {
      const { endDate, startDate, departureCenter, arrivalCenter, productType } = payload;
      console.log('123', startDate);
      const condit = new GenerateCondit({
        aggregators: [],
        dataSource: 'delivery_dis_accord_result',
        dimensions: [
          'locationMark',
          'waybillNo',
          'subBillNo',
          'loadCenter',
          'scanTime',
          '__time',
          'calcWeight',
          'planNextCenter',
          'planRoutePath',
          'actualNextCenter',
          'actualRoutePath',
          'timeDifference',
          'loadWorkerNo',
          'loadWorkerName',
          'loadProvinceArea',
          'actualNextProvinceArea',
          'locationMark',
          'originCenter',
          'destCenter',
          'productType',
        ],
        queryType: 'scan',
        simpleGranularity: 'all',
        endDate,
        startDate,
      });

      // 装车省区
      let loadProvinceAreas = undefined;
      // 装车分拨
      let loadCenters = undefined;
      if (departureCenter && departureCenter.length > 0) {
        if (departureCenter.length == 2) {
          loadCenters = departureCenter.lastItem;
        } else {
          loadProvinceAreas = departureCenter.lastItem;
        }
      }

      // 实际下一站省区
      let actualNextProvinceAreas = undefined;
      // 实际下一站分拨
      let actualNextCenters = undefined;
      if (arrivalCenter && arrivalCenter.length > 0) {
        if (arrivalCenter.length == 2) {
          actualNextCenters = arrivalCenter.lastItem;
        } else {
          actualNextProvinceAreas = arrivalCenter.lastItem;
        }
      }

      const entityTime = new DeliveryDisAccordRouteDetail({
        loadProvinceArea: loadProvinceAreas,
        loadCenter: loadCenters,
        productType: productType,
        actualNextProvinceArea: actualNextProvinceAreas,
        actualNextCenter: actualNextCenters,
      });
      const conditTime = condit.converCondit(entityTime);

      const result = yield crudRequest(
        '/api/route/exportTask/createTask',
        {
          taskName: '未按路由走货明细导出',
          taskType: 'delivery_dis_accord',
          isAllSite: 0,
          taskParams: JSON.stringify(condit),
        },
        { module: 'basic' },
      );
      if (result?.code === 1) {
        message.success('导出成功');
        // yield put({ type: 'updateState', payload: { messageInfo: result.message } });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
